import { store } from '@/store/index';

export const authState = () => {
  const state: any = store.getState();
  return state.auth;
};
